import { GET_ALL_SELECTBOX, ADD_SELECTBOX, UPDATE_SELECTBOX } from '../types'

const INITIAL_STATE = {
  allSelectbox: [],
  addSelectbox: [],
  updateSelectbox: [],
 

}

const selectboxReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_SELECTBOX:
      return {
        ...state,
        allSelectbox: payload,
      }
    case ADD_SELECTBOX:
      return {
        ...state,
        addSelectbox: payload,
      }
    case UPDATE_SELECTBOX:
      return {
        ...state,
        updateSelectbox: payload.id,
      }
    default:
      return state
  }
}

export default selectboxReducer
